import { Intro, Overview } from "../components";
export const storyblokComponents = {
    PartnershipsIntro: Intro,
    PartnershipsPartnerOverviewList: Overview
};
